/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { billingCountryIndex } from '../../axios/billingCountryIndex'
import type { BillingCountryIndexError, BillingCountryIndexResponse } from '../../types/BillingCountryIndex'

export const billingCountryIndexQueryKey = () => [{ url: '/billing-countries' }] as const

export type BillingCountryIndexQueryKey = ReturnType<typeof billingCountryIndexQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/BillingCountryController.php BillingCountryController::index */
export function billingCountryIndexQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		BillingCountryIndexResponse,
		AxiosError<BillingCountryIndexError>,
		BillingCountryIndexResponse,
		BillingCountryIndexQueryKey
	>({
		queryKey: billingCountryIndexQueryKey(),
		queryFn: ({ signal }) => billingCountryIndex({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/BillingCountryController.php BillingCountryController::index */
export function useBillingCountryIndex<TSelectData = BillingCountryIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					BillingCountryIndexResponse,
					AxiosError<BillingCountryIndexError>,
					TSelectData,
					BillingCountryIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<BillingCountryIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...billingCountryIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/BillingCountryController.php BillingCountryController::index */
export function useBillingCountryIndexSuspense<TSelectData = BillingCountryIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					BillingCountryIndexResponse,
					AxiosError<BillingCountryIndexError>,
					TSelectData,
					BillingCountryIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<BillingCountryIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...billingCountryIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
